import { PAGINATION_LIMIT } from '@constants/pagination';

export const countOffsetByPage = (page: number, limit: number = PAGINATION_LIMIT) =>
  (page === 1 ? 0 : (page - 1) * limit);
